import React from 'react'
import DetailCountdown from './DetailCountdown'

import styles from './CountdownBar.module.css'

const DEFAULT_COUNTDOWN_THEME = {
  background: "#FFF",
  color: "#ff8b8c"
}

const DetailCountdownBar = ({ clientStartDate, clientEndDate, background, textColor, countdownTheme }) => {

  let text
  let countdown = 0

  const now = new Date()

  const startDate = new Date(clientStartDate || now)
  const endDate = new Date(clientEndDate || now)

  if (now - startDate < 0) {
    text = 'STARTS IN'
    countdown = startDate - now
  } else if (now - endDate < 0) {
    text = 'ENDS IN'
    countdown = endDate - now
  }

  if (countdown <= 0) {
    return <div className={styles.countdownRow} style={{ background: background }}></div>
  }

  const theme = countdownTheme || DEFAULT_COUNTDOWN_THEME

  return (
    <div className={styles.countdownRow} style={{ background: background }}>
      <div className={styles.text} style={{ color: textColor }}>{text}</div>
      <DetailCountdown
        timestamp={countdown}
        type={DetailCountdown.TYPE.CLOCK}
        className={styles.countdown}
        {...theme}
      />
    </div>
  )
}

export default DetailCountdownBar
